var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 430,
    height: 430,
    viewBox: "0 0 430 430",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215 300C261.944 300 300 261.944 300 215C300 168.056 261.944 130 215 130C168.056 130 130 168.056 130 215C130 261.944 168.056 300 215 300ZM215 270C245.376 270 270 245.376 270 215C270 184.624 245.376 160 215 160C184.624 160 160 184.624 160 215C160 245.376 184.624 270 215 270Z",
    fill: "url(#paint0_linear_5956_1326)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M305 140C313.284 140 320 133.284 320 125C320 116.716 313.284 110 305 110C296.716 110 290 116.716 290 125C290 133.284 296.716 140 305 140Z",
    fill: "url(#paint1_linear_5956_1326)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115 55C81.8629 55 55 81.8629 55 115V315C55 348.137 81.8629 375 115 375H315C348.137 375 375 348.137 375 315V115C375 81.8629 348.137 55 315 55H115ZM315 85H115C98.4315 85 85 98.4315 85 115V315C85 331.569 98.4315 345 115 345H315C331.569 345 345 331.569 345 315V115C345 98.4315 331.569 85 315 85Z",
    fill: "url(#paint2_linear_5956_1326)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215 300C261.944 300 300 261.944 300 215C300 168.056 261.944 130 215 130C168.056 130 130 168.056 130 215C130 261.944 168.056 300 215 300ZM215 270C245.376 270 270 245.376 270 215C270 184.624 245.376 160 215 160C184.624 160 160 184.624 160 215C160 245.376 184.624 270 215 270Z",
    stroke: "#121331",
    strokeWidth: 7
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M305 140C313.284 140 320 133.284 320 125C320 116.716 313.284 110 305 110C296.716 110 290 116.716 290 125C290 133.284 296.716 140 305 140Z",
    stroke: "#121331",
    strokeWidth: 7
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115 55C81.8629 55 55 81.8629 55 115V315C55 348.137 81.8629 375 115 375H315C348.137 375 375 348.137 375 315V115C375 81.8629 348.137 55 315 55H115ZM315 85H115C98.4315 85 85 98.4315 85 115V315C85 331.569 98.4315 345 115 345H315C331.569 345 345 331.569 345 315V115C345 98.4315 331.569 85 315 85Z",
    stroke: "#121331",
    strokeWidth: 7
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5956_1326",
    x1: 67.9611,
    y1: 55,
    x2: 342.107,
    y2: 365.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BB3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#F28BA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755208,
    stopColor: "#FBB35E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5956_1326",
    x1: 67.9611,
    y1: 55,
    x2: 342.107,
    y2: 365.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BB3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#F28BA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755208,
    stopColor: "#FBB35E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5956_1326",
    x1: 67.9611,
    y1: 55,
    x2: 342.107,
    y2: 365.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BB3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#F28BA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755208,
    stopColor: "#FBB35E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC738"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.89ec4301e5d6dfea7b72c8e759837405.svg";
export { ForwardRef as ReactComponent };